import fp from 'lodash/fp';
import { API } from '@factorin/container.macro';

import { lookupTableReducer, reducePath } from 'Modules/core/redux';

import { downloadsActions } from './actions';


const actionLookup = {
    [`${downloadsActions.initialize}`]: () => fp.mapValues(fp.stubObject, API.domain),

    [`${downloadsActions.progress}`]: reducePath((state, { id, ...progress }) => ({
        ...state,
        [id]: progress,
    })),
    [`${downloadsActions.finish}`]: reducePath(({ ...state }, id) => {
        delete state[id];
        return state;
    }),
};

export const reducer = lookupTableReducer({}, actionLookup);
